import {_, React, observer} from '@api'
import {useCatalog} from '@stores'
import {ImageSourceToolbarButton} from '@modules'
import * as css from './PaginationToolbar.css'

type PaginationToolbarProps = any & { totalCount: number }

export const PaginationToolbar = observer<PaginationToolbarProps>(function MyPaginationToolbar(props) {
  const {settings: {imageSource}} = useCatalog()

  return (
    <div className={css.root}>
      {imageSource.toolbar?.location === 'footer' && <ImageSourceToolbarButton className={css.imageSources}/>}
    </div>
  )
})




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_CatalogItems/DataGrid/PaginationToolbar.tsx